import { render } from "./OrderSummary.vue?vue&type=template&id=a23dffac"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/WebstormProjects/ynamly_vue-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__